import { AwardedNomination } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardedNominations: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<AwardedNomination[]> = (fetchContext, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/awarded-nominations`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<AwardedNomination[]>(fetchContext.errorStore, response, 'get awarded nominations'));
